import * as React from 'react';
import { AutoSizer, Dimensions } from 'react-virtualized';

import { GridRow } from '../../typings/domain';
import { Grid, GridProps } from '../Grid/Grid';

interface AutoSizedGridProps<T extends GridRow> extends GridProps<T> {
    gridAdditionalHeight?: number;
}

export class AutoSizedGrid<T extends GridRow> extends React.PureComponent<AutoSizedGridProps<T>> {
    render() {
        const { gridAdditionalHeight = 0 } = this.props;

        return (
            <AutoSizer>
                {({ width, height }: Dimensions) => {
                    return <Grid {...this.props} width={width} height={height + gridAdditionalHeight} />;
                }}
            </AutoSizer>
        );
    }
}
